module.exports = __webpack_public_path__ + "static/media/dome.46ca99ac.svg";